var React = require('react');

function IconLinkedinBlackInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_awesome-linkedin-in","data-name":"Icon awesome-linkedin-in","d":"M5.372,24H.4V7.977H5.372ZM2.882,5.791A2.9,2.9,0,1,1,5.763,2.882,2.906,2.906,0,0,1,2.882,5.791ZM23.995,24H19.03V16.2c0-1.859-.038-4.243-2.587-4.243-2.587,0-2.983,2.02-2.983,4.109V24H8.489V7.977h4.772v2.186h.07a5.228,5.228,0,0,1,4.708-2.588C23.074,7.575,24,10.891,24,15.2V24Z","transform":"translate(0 -0.001)"}));
}

IconLinkedinBlackInline.defaultProps = {"width":"24","height":"23.999","viewBox":"0 0 24 23.999"};

module.exports = IconLinkedinBlackInline;

IconLinkedinBlackInline.default = IconLinkedinBlackInline;
